var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FavorabilityIconSvg,{attrs:{"less_is_better":_vm.less_is_better,"size":_vm.size,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }